import { render, staticRenderFns } from "./PageParametersForm.vue?vue&type=template&id=26fbf796"
import script from "./PageParametersForm.vue?vue&type=script&lang=js"
export * from "./PageParametersForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports